import pgrid from 'projection-grid';
import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import { DeterministicView } from '@bingads-webui/deterministic-view';
import { download } from '@bingads-webui/download-service';
import { FilePicker } from '@bingads-webui/file-picker';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { withUiBlock } from '@bingads-webui/uiblocker';
import { FeedUploadGridOption } from './grid-option';
import template from './template.pug';
import { feedErrorMapper } from './feed-error-map';
import { jsdataBhc } from '../../hotel-center-shared';

const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');
const UploadService = globalContext.require('component/azure-upload/index');

function upload(file) {
  const odataOptions = {
    cacheResponse: false,
    url: '/Customers(:advertisercustomer_id)/HotelFeedUploadLocation',
  };

  return jsdataBhc.HotelFeedUploadLocation.find('', odataOptions)
    .then((uploadLocation) => {
      const uploadService = new UploadService({
        blobSetting: {
          SasUrl: uploadLocation.uri,
          blobName: file.name,
        },
        file,
      });

      return uploadService.start();
    }).then((blobUri) => {
      const newFeed = {
        language: 'en', // For V1 language is hardcoded
        rawUri: blobUri,
        originalFileName: file.name,
      };

      return jsdataBhc.HotelFeed.create(newFeed, {
        cacheResponse: false,
        url: '/Customers(:advertisercustomer_id)/HotelFeeds',
      });
    });
}


export default class FeedUpload extends DeterministicView {
  initialize({ perfMarker = null }) {
    super.initialize();
    this.i18n = i18n;
    if (perfMarker) {
      this.perfMarker = perfMarker.createChild('HotelCenterFeedUpload');
      this.perfMarker.willInit();
    }
    this.setState({
      isUploadEnabled: false,
      isUploading: false,
      isFeedPending: false,
    });
    this.filePicker = new FilePicker({
      theme: 'default',
      allowedFileExtensions: ['.zip', '.tsv', '.csv', '.xml'],
      i18n,
      validator: () => {
        this.setState({ isUploadEnabled: true });
      },
      displayFilePath: 'filename',
    }).render();
    this.filePicker.on('error.extension', () => {
      this.setState({ isUploadEnabled: false });
    });
    const gridOption = new FeedUploadGridOption({ jsdataBhc });

    this.grid = pgrid.factory({ vnext: true })
      .use(uiBlockerPlugin)
      .create(gridOption);
    this.grid.gridView.render();

    this.fetchPendingSeed();
  }

  get template() {
    return template;
  }

  get events() {
    return {
      'click .btn-submit': () => {
        if (!this.filePicker.fileObject) {
          return;
        }
        this.setState({ isUploading: true });
        upload(this.filePicker.fileObject)
          .then(() => {
            // reset feedError
            this.setState({ feedError: null });
            this.grid.gridView.refresh();
          })
          .catch((err) => {
            const errorCode = err.errors && err.errors[0].Code;
            this.setState({ feedError: feedErrorMapper(errorCode) || i18n.getString('HotelCenter_Feed_Error_OtherError') });
          });
      },
      'click .feed-upload-grid .download-feed-error': 'downloadFeedError',
    };
  }

  downloadFeedError(e) {
    const item = this.grid.gridView.itemOfElement(e.target);
    if (item) {
      const feedId = item.Id;
      const odataOptions = {
        cacheResponse: false,
        url: `/Customers(:advertisercustomer_id)/HotelFeeds(${feedId})`,
      };

      jsdataBhc.HotelFeed.find(feedId, odataOptions)
        .then((response) => {
          download(response.matchingReportUri);
        });
    }
  }

  renderTrunk() {
    super.renderTrunk();
    if (this.perfMarker) {
      this.perfMarker.willRender();
    }
    const $filePicker = this.$('.file-picker');
    const $grid = this.$('.feed-upload-grid');

    $filePicker.append(this.filePicker.$el);
    $grid.append(this.grid.gridView.el);
    if (this.perfMarker) {
      this.perfMarker.done();
    }
    return this;
  }

  fetchPendingSeed() {
    const odataOptions = {
      cacheResponse: false,
      url: '/Customers(:advertisercustomer_id)/HotelFeeds',
    };
    const queryOptions = {
      where: { status: 'PENDING' },
      limit: 1,
    };

    jsdataBhc.HotelFeed.findAll(queryOptions, odataOptions)
      .then((response) => {
        this.setState({ isFeedPending: response.length > 0 });
      })
      .finally(withUiBlock(this.el));
  }
}
